/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { useHistory } from "react-router-dom";

import { useTextMessage } from '@fitinsur/hooks';

import { ButtonWithIcon, HasPermission } from "@fitinsur/components";

import * as S from './components/styles';

export function AccessNavigation({ permissions, match, ...props }) {
  const { getDescription } = useTextMessage();
  const history = useHistory();

  return (
    <HasPermission permission={permissions.MODULE_PERSON || permissions.MODULE_ACCESS_PROFILE || permissions.MODULE_ACCESS_GROUP}>
      <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "20px", marginBottom: "20px" }}>
        <S.Title>{getDescription("DOMAINS", 847, { withSkeleton: true, textFormat: 'uppercase' })}</S.Title>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
          {permissions.MODULE_PERSON && (
            <ButtonWithIcon
              width="140px"
              height="50px"
              onClick={() => {
                if (props.currentList === 'person') return;
                history.push("/management/58/person");
                props.setCurrentList("person")
              }}
              icon={{ name: "person" }}
              title={getDescription("DOMAINS", 775, { withSkeleton: true, textFormat: 'uppercase' })}
            />
          )}

          {permissions.MODULE_ACCESS_PROFILE && (
            <ButtonWithIcon
              width="140px"
              height="50px"
              onClick={() => {
                if (props.currentList === 'access-role') return;
                history.push("/management/58/access-role");
                props.setCurrentList("access-role")
              }}
              icon={{ name: "access" }}
              title={getDescription("DOMAINS", 776, { withSkeleton: true, textFormat: 'uppercase' })}
            />
          )}

          {permissions.MODULE_ACCESS_GROUP && (
            <ButtonWithIcon
              width="140px"
              height="50px"
              onClick={() => {
                if (props.currentList === 'access-group') return;
                history.push("/management/58/access-group");
                props.setCurrentList("access-group")
              }}
              icon={{ name: "group" }}
              title={getDescription("DOMAINS", 795, { withSkeleton: true, format: 'uppercase' })}
            />
          )}
        </div>
      </div>
    </HasPermission>
  );
}
